/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyAIAssistantOperatorTypename = "PharmacyAIAssistantOperator" as const;

/**
 *
 * @export
 * @interface PharmacyAIAssistantOperator
 */
export interface PharmacyAIAssistantOperator {
  /**
   *
   * @type {string}
   * @memberof PharmacyAIAssistantOperator
   */
  authId: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyAIAssistantOperator
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyAIAssistantOperator
   */
  idToken?: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyAIAssistantOperator
   */
  pharmacyId: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyAIAssistantOperator
   */
  refreshToken?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyAIAssistantOperator
   */
  readonly __typename?: string;
}

export function PharmacyAIAssistantOperatorFromJSON(json: any): PharmacyAIAssistantOperator {
  return PharmacyAIAssistantOperatorFromJSONTyped(json, false);
}

export function PharmacyAIAssistantOperatorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyAIAssistantOperator {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyAIAssistantOperatorTypename,

    authId: json["auth_id"],
    id: json["id"],
    idToken: !exists(json, "id_token") ? undefined : json["id_token"],
    pharmacyId: json["pharmacy_id"],
    refreshToken: !exists(json, "refresh_token") ? undefined : json["refresh_token"],
  };
}

export function PharmacyAIAssistantOperatorToJSON(object?: PharmacyAIAssistantOperator | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    auth_id: value.authId,
    id: value.id,
    id_token: value.idToken,
    pharmacy_id: value.pharmacyId,
    refresh_token: value.refreshToken,
  };
}
